import Model, { attr, belongsTo, hasMany, type HasMany } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type Agreement from 'invite-sign/models/agreement';
import type Flow from 'invite-sign/models/flow';

export default class AgreementPage extends Model {
  declare [Type]: 'agreement-page';

  @belongsTo('flow', { async: false, inverse: 'agreementPage' }) declare flow: Flow | null;
  @hasMany('agreement', { async: false, inverse: 'agreementPage' }) declare agreements: HasMany<Agreement>;

  @attr('boolean') declare enabled: boolean;

  agreementsWithout(agreementIds: string[]): Agreement[] {
    const agreements = this.agreements || [];
    const excludedIds = (agreementIds || []).map((agreementId) => agreementId.toString());

    return agreements.slice().filter((agreement) => {
      return !excludedIds.includes(agreement.id);
    });
  }
}
